// extracted by mini-css-extract-plugin
export default {"tab":"tabs_tab__SgntI","title":"tabs_title__XCykZ","subTitle":"tabs_subTitle__zgN4+"};